export default {
  name: 'contact',
  props: {
    msg: String
  }
}